import React from 'react';

import Text from '../Text';
import Locale from '../../Translate/Locale';

import WarningIcon from '../../../icons/error2.svg';

import styles from './LoadingError.scss';

type LoadingErrorProps = {
  errorText?: string;
};

function LoadingError({ errorText }: LoadingErrorProps) {
  return (
    <div className={styles.container} aria-label="loading-error">
      <div className={styles.content}>
        <WarningIcon className={styles.icon} />
        <Text className={styles.message}>
          <Locale>{errorText || 'Something went wrong'}</Locale>
        </Text>
      </div>
    </div>
  );
}

export default LoadingError;
